import React from 'react';
import {
    Box,
    Card,
    CardActions,
    CardContent,
    Button,
    Typography,
    CircularProgress
} from '@mui/material';

const statusToTextAndPercentage = (status) => {
    switch (status) {
        case "RAW":
            return [0, "Video is uploading to our servers"]
        case "QUEUED":
            return [10, "Waiting for an unused server..."]
        case "SUBMITTED":
            return [20, "Video submitted for processing"]
        case "PROCESSING":
            return [30, "Processing through our networks"]
        case "RESULTS":
            //this might be 100 instead of 50 if user didn't order visualisation
            return [70, "Prediction score ready"] 
        case "PROCESSED":
            return [100, "Visualization is ready"]
        default:
            return [-1, "Invalid status"]
    }
}

export const ProgressCard = React.memo(({ name, status }) => {

    const [progress, progressText] = statusToTextAndPercentage(status);

    return (
        <Card sx={{
            background: 'linear-gradient(#111111, #572EEA)',
            borderRadius: "24px",
            marginRight: "20px",
            minWidth: "250px"
        }}>
            <CardContent sx={{
                textAlign: 'center',
                margin: "-5%"
            }}>
                <p style={{ fontSize: 20, fontWeight: 400 }}>
                    {name.length > 15 ? name.substring(0, 15) + '...' : name}
                </p>
                <p style={{ fontSize: 16, fontWeight: 200 }}>
                    {progressText}
                </p>
            </CardContent>
            <CardActions sx={{ display: 'flex', justifyContent: 'center', margin: "-5%", marginBottom: "5%" }}>
                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                    <CircularProgress variant="determinate" style={{color: "#cccccc"}} size={100} value={progress} />
                    <Box
                        sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography variant="caption" component="div" style={{
                            color: "white",
                            fontSize: "24px",
                            fontWeight: 500
                        }}>
                            {`${progress}%`}
                        </Typography>
                    </Box>
                </Box>
            </CardActions>
        </Card>
    );
})